import html2canvas from "html2canvas";

const waitForImages = (root: HTMLElement): Promise<void> =>
  new Promise((resolve) => {
    const images = Array.from(root.querySelectorAll("img"));
    if (images.length === 0) {
      resolve();
      return;
    }

    let settled = 0;
    const done = () => {
      settled += 1;
      if (settled >= images.length) resolve();
    };

    images.forEach((img) => {
      if (img.complete) {
        done();
      } else {
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
      }
    });
  });

export const buildEmailImageFilename = (
  communicationId: number,
  subject?: string | null
): string => {
  const base = (subject || `email-${communicationId}`)
    .trim()
    .replace(/[^a-z0-9-_]+/gi, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);

  return `${base || `email-${communicationId}`}.png`;
};

export const downloadEmailAsImage = async (
  element: HTMLElement,
  filename: string
): Promise<void> => {
  await waitForImages(element);

  const canvas = await html2canvas(element, {
    useCORS: true,
    backgroundColor: "#ffffff",
    scale: 2,
    logging: false,
  });

  const link = document.createElement("a");
  link.download = filename;
  link.href = canvas.toDataURL("image/png");
  link.click();
};
